import { PanelManager } from '@databases/panel-types';

/**
 * A panel manager whose API intentionally does nothing.
 * It holds internal state that is never mutated.
 * Useful in modes where panels are unavailable (e.g. mobile).
 * All methods are safe to call—they are no-ops.
 */
export class NoOpPanelManager extends PanelManager {
  public override showPanel() {}
  public override hidePanel() {}
}
